<template>

      <div class="wrapper wrapper-content">

        <div v-if="bank_data.on_close_time">
          <ModalX
              :showModal="showModal"
              :input="deposit_detail"
              @closedModal="onClosedModal"
          />
        </div>

        <div class="container-fluid">
 
            <div class="">
              <div class="">
                <div class="col-lg-12">
                  <div class="ibox float-e-margins">
                    <div class="ibox-title">
                      <h5>
                        <router-link :to="{name: 'reqcredit'}" class="text-primary-new">แจ้ง ฝาก/ถอน</router-link> / {{ deposit_message }}
                      </h5>
                    </div>

                    <div class="ibox-content">

                      <form id="prepare_amount" ref="prepare_amount" v-show="uiStep === 'amount'" @submit.prevent="prepareAmount">

                        <div class="alert alert-success">
                          <div class="form-group has-feedback" >
                            <h4 class="col-xs-12" style="font-size:16px; text-align:left">ระบุจำนวนเงินที่ต้องการฝาก</h4>
                            <p>&nbsp;</p>
                            <div class="col-xs-12">

                              <div class="input-group">
                                <strong style="font-size:12px;color:red">จำนวนเงินขั้นต่ำ {{amount_limit}} บาท</strong>
                              </div>

                              <div class="input-group">

                                <!-- <span class="input-group-addon">฿</span> -->
                                <input type="text" name="amount" class="form-control" placeholder='จำนวนเงินที่ต้องการฝาก' id="amount" v-model="amount">
                                <span class="input-group-btn">
                                  <button class="btn btn-primary  btn-submit-money" type="submit">ตกลง</button>
                                </span>
                              </div>

                              <!-- <div class="input-group">
                                <strong style="font-size:12px;color:red">กรุณาระบุจำนวนเงินฝากเป็นจำนวนเต็มเท่านั้น ระบบจะทำการสุ่มทศนิยมให้เอง</strong>
                              </div> -->

                            <div class="alert alert-danger border border-danger text-center">                            
                              <h4 class="text-left text-danger m-b-sm" style="font-size: 14px; color: #a94442"> <i class="fa fa-exclamation-triangle"></i> กรุณาระบุยอดการฝากเป็นจำนวนเต็มเท่านั้น ทางระบบจะทำการสุ่มทศนิยมให้เอง </h4>
                            </div>

                            </div>

                            <p>&nbsp;</p>

                          </div>
                        </div>
                      </form>

                      <div class="col-lg-12"><p></p><p></p></div>

<form
  id="deposit_form"
  ref="depositform"
  v-show="uiStep === 'deposit'"
  @submit.prevent.once="processDeposit"
  class="m-t form-horizontal fv-form fv-form-bootstrap"
>

                        <div class="form-group">
                          <div class="col-xs-12 col-sm-6">
                            <div class="alert alert-success border border-success text-center">
                              <h3 class="text-center text-danger m-b-sm" style="font-size: 18px;">กรุณาโอนเงินจำนวน </h3>
                              <h2 class="text-center text-danger m-b-sm" style="font-size: 20px;"> <strong class="amount-random-decimal" style="font-size: 24px; color:blue;text-decoration:underline">{{ formatMoney(final_amount) }}</strong> บาท</h2>
                              <h2 class="text-left text-danger m-b-sm" style="font-size: 12px; color: #a94442"> <i class="fa fa-exclamation-triangle"></i>  โปรดระบุเศษให้ถูกต้อง และต้องโอนเงินจากบัญชีที่ตั้งค่าไว้เท่านั้น</h2>
                            </div>

                            <div class="alert alert-danger border border-danger text-center">
                              <h3 class="text-center m-b-sm" style="font-size: 18px; color: #040a58"> กรุณาใส่เวลาโอนเงินตามสลิป </h3>
                              <div class="col-xs-12">
                                <date-picker v-model="transaction_date" :config="options" placeholder='เวลาโอนเงินตามสลิป' style="height:55px; font-size:24px;" ></date-picker>
                              </div>
                              <p>&nbsp;</p>
                              <h2 class="text-left text-danger m-b-sm" style="font-size: 12px; color: #a94442"> <i class="fa fa-exclamation-triangle"></i>  โปรดระบุเวลาให้ถูกต้องตามเวลาที่ปรากฎในสลิป มิเช่นนั้นระบบจะไม่เติมเงินให้</h2>
                            </div>



                            <h2 class="text-center m-b-sm" style="font-size: 20px; color: #040a58"><b> บัญชีธนาคารของเว็บ {{ site_name }}</b></h2>

                            <div class="widget p-sm bank-detail">
                              <table class="table table-bordered table-striped m-t-sm">
                                <tbody>

                                  <tr>
                                    <th colspan="2" class="text-center" style="background-color: #f2dede;">
                                      <h2 class="text-left m-b-sm" style="font-size: 18px; color: #040a58"><b> บัญชีที่ท่านต้องโอนเงินเข้า </b></h2>
                                    </th>
                                  </tr>

                                  <tr>
                                    <th colspan="2" class="text-center">
                                      <h3> 

                                        <span id="logo-bank">
                                          <img :src="bank_data.logo">
                                        </span>
                                        
                                        <span id="name-bank"><strong> {{ bank_data.bank_name }}</strong></span>
                                      </h3>
                                    </th>
                                  </tr>
                                  <tr>
                                    <th>ชื่อบัญชี</th>
                                    <td><h3><span id="account-name">{{ bank_data.account_name }}</span></h3></td>
                                  </tr>
                                  <tr>
                                    <th>เลขที่บัญชี</th>
                                    <td v-clipboard="() => bank_data.account_number" v-clipboard:success="copySuccess">
                                      <h2><span id="account-number">{{ bank_data.account_number }}</span></h2>
                                      <div style="text-align: left;">
                                        <button class="btn btn-light btn-sm border border-secondary  mr-3" type="button">
                                          <i class="fa fa-copy"></i> COPY</button>
                                      </div>
                                    </td>
                                  </tr>

                                  <tr>
                                    <th>จำนวนเงิน</th>
                                    <td>
                                      <h2><span id="deposit-value">{{ formatMoney(final_amount) }}</span></h2>
                                    </td>
                                  </tr>

                                </tbody>
                              </table>
                            </div>

                            <h2 class="text-center m-b-sm" style="font-size: 20px; color: #040a58"><b><i class="fa fa-long-arrow-down"></i> แจ้งรายละเอียดการโอนเงิน <i class="fa fa-long-arrow-down"></i></b></h2>

                            <div class="widget p-sm-gray bank-detail">
                              <table class="table table-bordered table-striped m-t-sm">
                                <tbody>

                                  <tr>
                                    <th colspan="2" class="text-center" style="background-color: #d9edf7;">
                                      <h2 class="text-left m-b-sm" style="font-size: 18px; color: #040a58"><b> โดยโอนจากบัญชีของท่าน </b></h2>
                                    </th>
                                  </tr>

                                  <tr>
                                    <th colspan="2" class="text-center">
                                      <h3> 
                                        <span id="logo-bank">
                                          <img :src="userData.bank_logo">
                                        </span>
                                        
                                        <span id="name-bank"><strong> {{ bank_mapping[userData.bank_id] }}</strong></span>
                                      </h3>
                                    </th>
                                  </tr>
                                  <tr>
                                    <th>ชื่อบัญชี</th>
                                    <td><h3><span id="account-name">{{ userData.bank_name }}</span></h3></td>
                                  </tr>
                                  <tr>
                                    <th>เลขที่บัญชี</th>
                                    <td>
                                      <h2><span id="account-number">{{ userData.bank_account }}</span></h2>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          </div>
                        </div>


                        <div class="form-group">
                          <label class="col-xs-12 col-lg-1 control-label" style="text-align:left"></label>
                          <div class="col-xs-12 col-sm-6">
                            <small>กรุณาตรวจสอบข้อมูลของท่านให้ถูกต้อง และกดปุ่ม <span class="text-success">ตกลง</span></small>
                          </div>
                        </div>

                        <div class="form-group">
                          <label class="col-xs-12 col-lg-1 control-label" style="text-align:left"></label>
                          <div class="col-xs-12 col-sm-6">
                            <button class="btn btn-xs-block btn-info" type="submit"><i class="fa fa-plus-circle"></i> ตกลง</button>
                            <button class="btn btn-xs-block btn-danger" @click="cancelDeposit" type="button">ยกเลิกการแจ้งฝาก</button>
                          </div>
                        </div>

                        <div class="alert alert-info border border-info text-center">
                          <h4 class="text-left text-danger m-b-sm" style="font-size: 14px; color: #3b5898"> หากเกิดข้อผิดพลาดหรือมีข้อสงสัย ท่านสมาชิกสามารถ <span class="text-danger">ติดต่อแอดมิน/คอลเซ็นเตอร์ ผ่านทางไลน์ <a :href="line_contact" target="_blank">{{line_name}}</a></span> เพื่อสอบถามได้ค่ะ </h4>
                        </div>

                      </form>

                    </div> <!-- /.ibox-content -->
                  </div> <!-- /.ibox -->
                </div> <!-- /.col-lg-12 -->
              </div> <!-- /.row -->
            </div>
 
        </div>
      </div><!-- /#page-wrapper -->

</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ModalX from '../Layouts/ModalPopup'

//import 'bootstrap/dist/css/bootstrap.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'

export default {
    name: 'deposit',
    components:{
        ModalX
    },
    data () {
        return {
            transaction_date: null,
            amount: '',
            final_amount: '',
            description: '',
            options: {
                //inline: true,
                // sideBySide: true,
                // format: 'YYYY-MM-DD HH:mm',
                // // minDate: moment(),
                // // maxDate: moment(),
                format: 'LT',
                useCurrent: false,
                showClear: true,
                showClose: true,
                //locale: moment.locale('th')
            },
            bank_data: {},
            isOpen: false,
            site_name: '',
            line_contact: '',
            line_name: '',
            amount_limit: 20,
            userData: {},
            uiStep: 'amount',   // 'amount' | 'deposit'
            debugError: '',     // เอาไว้โชว์ error บนหน้า

            bank_mapping: {
                "BBL": "ธ.กรุงเทพ",
                "KBANK": "ธ.กสิกรไทย",
                "KTB": "ธ.กรุงไทย",
                "SCB": "ธ.ไทยพาณิชย์",
                "BAY": "ธ.กรุงศรีอยุธยา",
                "CIMB": "ธ.ซีไอเอ็มบี",
                "IBANK": "ธ.อิสลามแห่งประเทศไทย",
                "KK": "ธ.เกียรตินาคิน",
                "LHB": "ธ.แลนด์ แอนด์ เฮ้าส์",
                "SC": "ธ.สแตนดาร์ดชาร์เตอร์ด (ไทย)",
                "TBANK": "ธ.ธนชาต",
                "TISCO": "ธ.ทิสโก้",
                "TMB": "ธ.ทหารไทย",
                "TTB": "ธ.ทหารไทยธนชาต",
                "UOB": "ธ.ยูโอบี",
                "TCD": "ธ.ไทยเครดิตเพื่อรายย่อย",
                "ICBC": "ธ.ไอซีบีซี (ไทย)",
                "BAAC": "ธ.เพื่อการเกษตรและสหกรณ์การเกษตร",
                "GSB": "ธ.ออมสิน",
                "GHB": "ธ.อาคารสงเคราะห์",

            },
            line_logo: '',
            showModal: true,
            deposit_detail: {
                header: 'แจ้งเรื่องโอนเงิน',
                body: '<p>กรุณาอย่าโอนเงินช่วงเวลา DEPOSIT_CLOSE_TIME น. ทางเว็บจะปิดรับแจ้งฝากเงินในเวลาดังกล่าว เนื่องจากปัญหาการรับยอดจากธนาคาร&nbsp;</p><p>ขออภัยในความไม่สะดวก</p>',
            },
            deposit_message: 'แจ้งเติมเครดิต',
            refer_task_id: '',
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            lineContact: state => state.information.lineContact,
        })
    },
    async mounted () {

        this.site_name = process.env.VUE_APP_SITE

        if (this.lineContact.link || this.lineContact.name){
            this.line_contact = this.lineContact.link
            this.line_name = this.lineContact.name
        }
        else {
            await this.loadLineContact()
        }

        this.line_logo = require('@/assets/images/'+ 'LINE_APP.png')

        let taskId = this.$route.query.taskId

        if (taskId) {

            this.deposit_message = 'แก้ไขเวลาแจ้งฝาก'
            this.refer_task_id = taskId

            this.$refs.prepare_amount.style["display"] = "none"
            this.$refs.depositform.style["display"] = "none"
            try {
                const response = await this.$store.dispatch('jobtask/getJobtask', taskId)

                if ( response.status_id == 3 ) {
                    let end_edit_time = moment(response.updated_at).add(180, 'minutes')

                    if ( moment().isSameOrBefore(end_edit_time) ) {

                        if ( response.bank_code ) {
                            // replace bank data
                            this.bank_data.id = response.bank_id
                            this.bank_data.bank_code = response.bank_code
                            this.bank_data.bank_name = response.bank_name
                            this.bank_data.account_number = response.account_number
                            this.bank_data.account_name = response.account_name

                            let logo = (this.bank_data.bank_code).toLowerCase() + '.png'
                            this.bank_data.logo = require('@/assets/images/banks/'+ logo)

                            // replace amount
                            this.final_amount = parseFloat(response.amount).toFixed(2)

                            this.$refs.prepare_amount.style["display"] = "none"
                            this.$refs.depositform.style["display"] = "block"

                            this.loadUserData()

                        }
                        else {
                            this.$toasted.error('ไม่สามารถแก้ไขเวลาแจ้งฝากได้ ไม่มีข้อมูลธนาคาร')
                            this.$router.push({name: 'reqcredit',})
                        }

                    }
                    else {
                        this.$toasted.error('ไม่สามารถแก้ไขเวลาแจ้งฝากได้ หมดเวลาแก้ไข')
                        this.$router.push({name: 'reqcredit',})
                    }

                }
                else {
                    this.$toasted.error('ไม่สามารถแก้ไขเวลาแจ้งฝากได้ สเตตัสไม่ถูกต้อง')
                    this.$router.push({name: 'reqcredit',})
                }

            } catch (error) {
                console.log('error', error)
                this.$toasted.error('There was an error connecting to the server.')
                this.$router.push({name: 'reqcredit',})
            } finally {
                this.$root.$emit('navbar')
            }
        }
        else {

            let processDepositAmount = localStorage.getItem('processDepositAmount') ? localStorage.getItem('processDepositAmount') : null
            let retrievedBankData = localStorage.getItem('bankData') ? localStorage.getItem('bankData') : null

            // to continue need amount and bank data from localstorage
            if ( processDepositAmount && retrievedBankData ) {

                let user_id = this.user.id

                let depositAmountObj = JSON.parse(processDepositAmount)
                let retrievedBankObj = JSON.parse(retrievedBankData)

                await this.getActiveBankData( retrievedBankObj[user_id]['id'] )

                if ( depositAmountObj[user_id] && retrievedBankObj[user_id] && this.bank_data.id ) {
                    this.final_amount = depositAmountObj[user_id]
                    this.bank_data = retrievedBankObj[user_id]

                    this.$refs.prepare_amount.style["display"] = "none"
                    this.$refs.depositform.style["display"] = "block"
                }

            }
            else {
                await this.getActiveBankData()
            }
        }

    },
    methods: {
        toggle: function(){
            this.isOpen = !this.isOpen
        },
        endCallBack: function (x) {
            // console.log('endcall', x)
            this.$toasted.error('ไม่สามารถทำรายการได้ หมดเวลาในการทำรายการ')

            localStorage.removeItem('processDepositAmount')
            localStorage.removeItem('bankData')

            this.$router.push({name: 'reqcredit',})
        },

        cancelDeposit () {
            this.$toasted.error('ยกเลิกการแจ้งฝาก')

            localStorage.removeItem('processDepositAmount')
            localStorage.removeItem('bankData')

            this.$router.push({name: 'reqcredit',})
        },

        async loadUserData () {
            if ( !this.user) {
                return
            }

            try {
                const response = await this.$store.dispatch('user/getUserData', this.user.id)
                //console.log('loadUserData response: ', response)

                this.userData = response

                this.userData.bank_id = (this.userData.bank_id).toUpperCase()
                let user_logo = (this.userData.bank_id).toLowerCase() + '.png'

                this.userData.bank_logo = require('@/assets/images/banks/'+ user_logo)

                return this.userData

            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
                // this.$store.dispatch('user/userLogout')
            }
        },

        prepareAmount () {
            this.debugError = ''

            try {
                if (!(parseFloat(this.amount) >= parseFloat(this.amount_limit) && this.validateNumber(this.amount))) {
                    this.$toasted.error('จำนวนเงินไม่ถูกต้อง จำนวนเงินต้องมากกว่า 0 (ขั้นต่ำ ' + this.amount_limit +  ') และเป็นตัวเลขจำนวนเต็มเท่านั้น.')
                    this.uiStep = 'amount'
                    return
                }

                // กันเคส user หรือ bank_data ยังไม่พร้อม
                if (!this.user || !this.user.id) {
                    this.debugError = 'prepareAmount: this.user.id is missing'
                    this.uiStep = 'amount'
                    return
                }
                if (!this.bank_data || !this.bank_data.id) {
                    this.debugError = 'prepareAmount: bank_data.id is missing'
                    this.uiStep = 'amount'
                    return
                }

                // 1) สุ่ม/ตั้ง final_amount ก่อน
                if (this.bank_data.skip_decimal) {
                    this.final_amount = parseFloat(this.amount).toFixed(2)
                } else {
                    var temp_decimal = Math.floor(Math.random() * 90 + 10)
                    var final_number = parseFloat(this.amount) + (temp_decimal / 100)
                    this.final_amount = final_number.toFixed(2)
                }

                // 2) เขียน localStorage แบบ safe (ไม่มี JSON.parse(null))
                var processDepositAmountStr = localStorage.getItem('processDepositAmount')
                var retrievedBankDataStr = localStorage.getItem('bankData')

                var depositAmountObj = {}
                var retrievedBankObj = {}

                try { depositAmountObj = processDepositAmountStr ? JSON.parse(processDepositAmountStr) : {} } catch (e) { depositAmountObj = {} }
                try { retrievedBankObj = retrievedBankDataStr ? JSON.parse(retrievedBankDataStr) : {} } catch (e) { retrievedBankObj = {} }

                if (!depositAmountObj || typeof depositAmountObj !== 'object') depositAmountObj = {}
                if (!retrievedBankObj || typeof retrievedBankObj !== 'object') retrievedBankObj = {}

                var user_id = this.user.id
                depositAmountObj[user_id] = this.final_amount
                retrievedBankObj[user_id] = this.bank_data

                localStorage.setItem('processDepositAmount', JSON.stringify(depositAmountObj))
                localStorage.setItem('bankData', JSON.stringify(retrievedBankObj))

                // 3) สลับ UI ด้วย state (ไม่แตะ refs)
                this.uiStep = 'deposit'

            } catch (e) {
                // ถ้ามีอะไรพัง จะไม่ blank แล้ว แต่จะโชว์ error
                console.log('prepareAmount error:', e)
                this.debugError = 'prepareAmount crashed: ' + (e && e.message ? e.message : String(e))
                this.uiStep = 'amount'
            }
        },

        copySuccess ({ value, event }) {
            //console.log('success', value, event)
            this.$toasted.success('คัดลอกเลขบัญชีเรียบร้อยแล้ว.')
        },

        async getActiveBankData (bank_id) {
            try {
                this.bank_data = {}

                const response = await this.$store.dispatch('jobtask/getActiveBankData', bank_id)
                //console.log('getActiveBankData: ', response)

                if ( response ) {

                    this.bank_data = response

                    let logo = (this.bank_data.bank_code).toLowerCase() + '.png'
                    this.bank_data.logo = require('@/assets/images/banks/'+ logo)

                    if (this.bank_data.deposit_limit) {
                        this.amount_limit = this.bank_data.deposit_limit
                    }

                    this.loadUserData()
                }

            } catch (error) {
                let error_msg = 'Hmm, something you entered doesn\'t seem right.'
                let response = error.response.data
                if ( response ) {

                    if ( response.message == 'INVALID_REQUEST_BANK_NOT_ACTIVE' ) {
                        // bank inactive, clear all local storage
                        localStorage.removeItem('processDepositAmount')
                        localStorage.removeItem('bankData')

                        error_msg = 'ยกเลิกการแจ้งฝากที่คงค้าง ธนาคารไม่พร้อมให้บริการ ' + response.message
                    }
                    else {
                        error_msg = 'ยังไม่เปิดให้แจ้งเติมเครดิต, ทางระบบยังไม่พร้อมให้บริการ ' + response.message
                    }
                }

                this.$toasted.error(error_msg)
                this.$router.push({name: 'reqcredit',})
            }
        },

        async processDeposit () {
            //console.log('processDeposit amount, transaction_date', this.amount, this.transaction_date)

            if ( parseFloat(this.final_amount) >= this.amount_limit && this.validateMoney(this.final_amount) ) {

                let trans_time = this.transaction_date
                //console.log('trans_time', trans_time)

                if ( !trans_time ) {
                    this.$toasted.error('กรุณาใส่เวลาฝากเงินให้ถูกต้อง ไม่เช่นนั้นจะไม่สามารถแจ้งฝากได้')
                    return
                }

                let [hh, mm] = trans_time.split(':')
                //console.log('split raw_tran_date', hh, mm)

                let raw_tran_date =  moment().hour(hh).minute(mm).second(0).format('YYYY-MM-DD HH:mm')

                let depositData = {
                    customer_id: this.user.id,
                    amount: this.final_amount,
                    action: 'debit', 
                    description: String(this.refer_task_id),
                    status_id: 1,
                    transaction_date: raw_tran_date,
                    bank_id: this.bank_data.id
                }

                //console.log('depositData', depositData)

                try {
                    const responseCreate = await this.$store.dispatch('jobtask/createJobtask', depositData)
                    //console.log('createJobtask responseCreate', responseCreate)

                    if ( responseCreate && responseCreate.data.message == 'SUCCESS' ) {
                        this.$toasted.success('ได้รับการแจ้งฝากแล้ว.')
                    }
                    else {

                        if ( responseCreate.data.desc == 'DUPLICATE_REQUEST' ) {
                            this.$toasted.error('ไม่สามารถทำรายการได้ เนื่องจากยังมีรายการแจ้งฝากก่อนหน้า ค้างอยู่ในระบบ')
                        }
                        else if ( responseCreate.data.desc == 'DUPLICATE_ALREADY_REQUEST' ) {
                            this.$toasted.error('ไม่สามารถทำรายการได้ เนื่องจากท่านแจ้งเวลาฝากซ้ำกันกับรายการแจ้งฝากก่อนหน้า')
                        }
                        else if ( responseCreate.data.desc == 'DUPLICATE_TRANSAC_DATE' ) {
                            this.$toasted.error('ไม่สามารถทำรายการได้ เนื่องจากท่านแจ้งเวลาฝากซ้ำ/เวลาใกล้เคียงกับรายการแจ้งฝากก่อนหน้ามากเกินไป')
                        }
                        else {
                            this.$toasted.error(responseCreate.data.desc)
                        }
                    }
                    this.$router.push({name: 'reqcredit',})

                } catch (error) {
                    this.$toasted.error('There was an error connecting to the server.')
                }
                finally {

                    let processDepositAmount = localStorage.getItem('processDepositAmount') ? localStorage.getItem('processDepositAmount') : null
                    let retrievedBankData = localStorage.getItem('bankData') ? localStorage.getItem('bankData') : null

                    let user_id = this.user.id

                    let depositAmountObj = JSON.parse(processDepositAmount)
                    let retrievedBankObj = JSON.parse(retrievedBankData)

                    delete depositAmountObj[user_id]
                    delete retrievedBankObj[user_id]

                    if ( typeof depositAmountObj === 'object' && Object.keys(depositAmountObj).length > 0 ) {
                        // Object and not empty
                        localStorage.setItem('processDepositAmount', JSON.stringify(depositAmountObj))
                        localStorage.setItem('bankData', JSON.stringify(retrievedBankObj))
                    }
                    else {
                        // NOT object OR empty object
                        localStorage.removeItem('processDepositAmount')
                        localStorage.removeItem('bankData')
                    }

                }

            }
            else {
                this.$toasted.error('จำนวนเงินไม่ถูกต้อง จำนวนเงินต้องมากกว่า 0 (ขั้นต่ำ ' + this.amount_limit +  ') และเป็น ตัวเลข และ/หรือ จุดทศนิยม 2 ตำแหน่งเท่านั้น.')
            }
        },

        formatMoney(num) {
            if (num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            }
            return num
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        validateMoney (amount) {
            let rgx = /^[0-9]+(\.[0-9]{1,2})?$/g
            return amount.match(rgx)
        },

        validateNumber (amount) {
            let rgx = /^[0-9]+$/g
            return amount.match(rgx)
        },

        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
                this.line_name = response.name

            } catch (error) {
                console.log('error', error)
            }
        },

        onClosedModal(){
            this.showModal = false
            this.$router.go(-1)
        }
    },
}
</script>

<style lang="css" scoped>

th, td {
  padding: 5px;
  text-align: left;
}

.p-sm {
    padding: 15px;
    border: 4px solid #eb1639;
}

.p-sm-gray {
    padding: 15px;
    border: 4px solid #15cbf0;
}

@keyframes fa-blink {
     0% { opacity: 1; }
     25% { opacity: 0.25; }
     50% { opacity: 0.5; }
     75% { opacity: 0.75; }
     100% { opacity: 0; }
 }
.fa-blink {
   -webkit-animation: fa-blink .75s linear infinite;
   -moz-animation: fa-blink .75s linear infinite;
   -ms-animation: fa-blink .75s linear infinite;
   -o-animation: fa-blink .75s linear infinite;
   animation: fa-blink .75s linear infinite;
}

</style>

